export const textValidator = (
  value: string,
  cb: (m?: string) => void,
  message: string,
  minLength = 0
) => {
  const text = value?.replace(/<[^>]*>/g, '').trim() as string;

  if (!value || text === '' || text.length < minLength) {
    cb(message);
  }

  cb();
};

export const PERSON_NAME_REGEX = /^[\p{L}\s'\-–—]+$/u;

export const getFullNameValidationError = (
  value: string | undefined,
  fieldLabel = 'Nome Completo'
) => {
  const trimmedValue = value?.trim();

  if (!trimmedValue) {
    return undefined;
  }

  if (trimmedValue.split(/\s+/).length < 2) {
    return `${fieldLabel} deve ter ao menos nome e sobrenome`;
  }

  if (!PERSON_NAME_REGEX.test(trimmedValue)) {
    return `${fieldLabel} deve conter apenas letras, espaços, hífens ou apóstrofos`;
  }

  return undefined;
};

export const isValidFullName = (value: string) =>
  Boolean(value?.trim()) && !getFullNameValidationError(value);

export const fullNameValidatorRule =
  (fieldLabel = 'Nome Completo') =>
  () => ({
    validator(_: unknown, value: string) {
      const errorMessage = getFullNameValidationError(value, fieldLabel);

      if (!errorMessage) {
        return Promise.resolve();
      }

      return Promise.reject(new Error(errorMessage));
    }
  });
